export const stepContent = [
  {
    title: "What do you do?",
    description:
      "We will tailor the sandbox assignments to the exact style of work you actually encounter day-to-day.",
  },
  {
    title: "What would you like to practise?",
    description:
      "Choose a tool platform to see relevant real-world exercises mapped to your tech stack.",
  },
  {
    title: "How much guidance do you want?",
    description:
      "This controls how detailed the instructions will be. You can change this anytime.",
  },
  {
    title: "Here are some tasks you can try",
  },
];
